export default __webpack_public_path__ + "static/media/coverpage-01.4b8c0c25.jpg";